<template>
	<div class="admin-basic-container">
		<el-card class="search-card">
			<el-form inline label-width="80px">
				<el-form-item label="标识">
					<el-input v-model="code" placeholder="请输入标识"></el-input>
				</el-form-item>
				<el-form-item label="名称">
					<el-input v-model="name" placeholder="请输入名称"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="status" placeholder="全部" clearable>
						<el-option label="全部状态" value="-1"></el-option>
						<el-option label="未启用" value="0"></el-option>
						<el-option label="启用" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
					<el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<div class="btn-group" style="margin:16px 0;">
			<el-button type="primary" icon="el-icon-plus" @click="openDialog">新增配置</el-button>
		</div>
		<el-card>
			<el-table :data="tableData" border stripe v-loading="loading">
				<el-table-column label="ID" prop="id" width="80"></el-table-column>
				<el-table-column label="标识" prop="code"></el-table-column>
				<el-table-column label="名称" prop="name"></el-table-column>
				<el-table-column label="值" prop="value"></el-table-column>
				<el-table-column label="状态" prop="status" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
							{{ scope.row.status === 1 ? '启用' : '未启用' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="createTime" width="180">
					<template slot-scope="scope">
					{{forTime(scope.row.createTime)}}
					</template>
					
				</el-table-column>
				<el-table-column label="更新时间" prop="updateTime" width="180">
					<template slot-scope="scope">
					{{forTime(scope.row.updateTime)}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" type="text" @click="editRow(scope.row)">编辑</el-button>
						<el-button size="mini" type="text" @click="handleDelete(scope.row)"
							class="text-danger" v-if="scope.row.status!=1">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize"
				layout="total, prev, pager, next, jumper" :total="total"
				style="margin-top:16px;text-align:right"></el-pagination>
		</el-card>
		<el-dialog :title="title" :visible.sync="dialogVisible" width="500px" center>
			<el-form :model="form" ref="formRef" label-width="90px">
				<el-form-item label="标识" prop="code" :rules="formRef.code">
					<el-input v-model="form.code" placeholder="唯一标识"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name" :rules="formRef.name">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="值" :rules="formRef.value">
					<el-input v-model="form.value" type="text" ></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="form.status">
						<el-option label="未启用" :value="0"></el-option>
						<el-option label="启用" :value="1"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitForm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'AdminBasic',
		data() {
			return {
				loading: false,
				code: '',
				name: '',
				status: "-1",
				pageNum: 1,
				pageSize: 10,
				total: 0,
				tableData: [],
				dialogVisible: false,
				title: '新增配置',
				formRef:{
				      code: [{ required: true, message: '请输入标识', trigger: 'blur' }],
				      name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
					  value: [{ required: true, message: '请输入值', trigger: 'blur' }]
				    },
				form: {
					id: null,
					code: '',
					name: '',
					value: '',
					status: 1
				},
				login: null,
			}
		},
		created() {
			this.getList()
		},
		methods: {
			forTime(val){
				if(!val) return ''
				return val.replace('T',' ')
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			async getList() {
				this.loginOpen('查询中...')
				try {
					const res = await this.API.get(this.API.admin.getBasicList, {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						code: this.code,
						name: this.name,
						status: this.status == -1 ? '' : this.status,
					})
					
					this.tableData=res.data?.records || []
					this.total=res.data?.total||0
				} catch (error) {

				} finally {
					this.noLogin()
				}
			},
			resetSearch() {
				this.code = ''
				this.name = ''
				this.status = -1
				this.getList()
			},
			handleCurrentChange(val) {
				this.pageNum = val
				this.getList()

			},
			openDialog() {
				this.title = '新增配置'
				this.form = {
					id: null,
					code: '',
					name: '',
					value: '',
					status: 1
				}
				this.dialogVisible = true
			},
			editRow(row) {
				this.title = '编辑配置'
				this.dialogVisible = true
				this.form = {
					...row
				}

			},
			async submitForm() {
				if (!this.form.code) return this.$message.error('唯一code未填写')
				if (!this.form.name) return this.$message.error('名称未填写')
				if (!this.form.value) return this.$message.error('值未填写')
				let res = {}
				if (this.form.id) {
					this.loginOpen('修改配置中...')
				} else {
					this.loginOpen('新增配置中...')
				}
				if (this.form.id) {
					res = await this.API.put(this.API.admin.putBasicUpdate, this.form)
				} else {
					res = await this.API.post(this.API.admin.postBasicAdd, this.form)
				}
				
				if(res.status==200){
					this.dialogVisible = false
					this.getList()
					if(this.form.id){
						this.$message.success('修改成功')
					}else{
						this.$message.success('新增成功')
					}
				}
				this.noLogin()
				
			},
			handleDelete(row) {
				this.$confirm('确定删除该配置？删除后不可恢复', '提示', {
					type: 'warning'
				}).then(()=>{
					this.API.deleted(this.API.admin.deletedBasicId + row.id).then(res=>{
						if(res.status==200){
							this.getList()
							this.$message.success('删除成功')
						}else{
							this.$message.success('删除失败')
						}
					}).catch(()=>{
						this.$message.success('删除失败')
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped>
	.admin-basic-container {
		padding: 16px;
	}

	.search-card {
		margin-bottom: 10px;
	}

	.text-danger {
		color: #f56c6c;
	}
</style>